<template>
  <div>   
    <vx-card class="mb-1" :collapseAction="true" title="Filtro">
       <vs-row vs-type="flex" vs-justify="space-between" class="mb-2">         
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="4">         
              <label class="vs-input--label mr-2">Nome do Fornecedor</label>              
              <vs-input class="w-full" v-model="filtro.nomeFavorecido" @keyup.enter="fetchLista()" style="padding-right: 5px;" />
          </vs-col>                 
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="5">       
            <label class="vs-input--label mr-2">Período</label>              
            <div class="flex items-center">
              <flat-pickr v-model="filtro.dataCompraInicio" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker" />
              <label class="vs-input--label mr-2">à</label>
              <flat-pickr v-model="filtro.dataCompraFim" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"/>
            </div>           
          </vs-col>  
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="3"> 
             <label class="vs-input--label">Status</label>              
             <v-select                                               
                :options="CONSTANTE_STATUS_COMPRA" 
                v-model="filtro.status"      
                :reduce="d => d.data"                              
                class="v-select w-full ml-1"
                style="padding-right: 10px;" >
             </v-select>
          </vs-col>          
       </vs-row>
       <vs-row vs-type="flex" vs-justify="space-between" >
          <vs-col vs-type="flex" vs-w="4" vs-justify="center">
          </vs-col>
          <vs-col vs-type="flex" vs-w="5" vs-justify="center">
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" size="small" icon="icon-arrow-left" @click="setMes(false)"> </vs-button>
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" size="small" icon="icon-calendar" @click="setMesAtual"></vs-button>
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" size="small" icon="icon-arrow-right" @click="setMes(true)"> </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="3">
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="fetchLista()"></vs-button>
            <vs-button class="mr-2" color="dark" type="border" icon-pack="feather" icon="icon-file" @click="limparFiltros"></vs-button>  
            <vs-button class="mr-2" color="warning" type="filled" icon-pack="feather" icon="icon-plus" @click="routeNovoRegistro"></vs-button>          
            <vs-button color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-save" @click="exportarParaCSV"></vs-button>          
          </vs-col>
      </vs-row>
    </vx-card>
    <div class="flex">
      <h6 class="mt-2 mb-2 text-danger"> [ {{dadosDaGrid.length }} ] </h6>      
    </div>
    
    <vx-card class="mb-1">
      <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="dadosDaGrid"
        :rowHeight="30"
        :headerHeight="25"        
        rowSelection="single"
        colResizeDefault="shift"
        @row-selected="onRowSelectedRegistro"    
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :paginationAutoPageSize="false"
        :suppressPaginationPanel="true"
        >
      </ag-grid-vue>      
    </vx-card>
    
  </div>

</template>

<script>

import axios from "@/axios.js"
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

const URL_SERVLET = "/Compra/Listar";
const NAME_ROUTE_EDIT = "financeiro-compras-editar";

import { CONSTANTE_STATUS_COMPRA } from '@/constantesComboBox.js'

export default {
  components: {
    AgGridVue,
    flatPickr
  },
  props: {    
    filtroInicial: {
      type: Object    
    }    
  },
  data() {
    return {
      filtro : { dataCompraInicio:  null, dataCompraFim : null, status: null, nomeFavorecido: null },
      configuracaoGrid: { 
          gridApi: null, 
          gridOptions: {
            rowClassRules: {          
              'rag-green-outer': function(params) { return params.data.status === 'SOLICITADA'; },              
              'rag-amber-outer':   function(params) { return params.data.status === 'APROVADA'; },
            },
          }, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [        
            { headerName: 'N.', field: 'id', width: 35, cellRenderer: function(params) { return "<strong>" + params.data.id+ "</strong>"} },                                   
            { headerName: 'FORNECEDOR', field: 'favorecido.nome'},                
            { headerName: 'COMPRA', field: 'dataCompraFormatado', width: 45},     
            { headerName: 'NOTA FISCAL', field: 'conta.numeroNotaFiscal'},               
            { headerName: 'VENCIMENTO', field: 'vencimentoFormatado', width: 45},                                         
            { headerName: 'STATUS', field: 'status', width: 75},                
          ]
      },
      configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "Y-m-d", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
          locale: PortugueseLocale
      },
      dadosDaGrid: [],
      totalRegistros: 0,
      numeroMesAtual: 0,
    }
  },  
  created() {
    this.CONSTANTE_STATUS_COMPRA = CONSTANTE_STATUS_COMPRA;
  },
  computed: {
   
  },
  methods: {
    setMes(incrementar){
      
      if (incrementar) {
        this.numeroMesAtual = this.numeroMesAtual + 1;
      } else {
        this.numeroMesAtual = this.numeroMesAtual - 1;
      }

      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth() + this.numeroMesAtual, 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1 + this.numeroMesAtual, 0);


      this.filtro.dataCompraInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataCompraFim = lastDay.toISOString().split('T')[0];
    },
    setMesAtual(){
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataCompraInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataCompraFim = lastDay.toISOString().split('T')[0];
      this.numeroMesAtual = 0;
    },
    limparFiltros() {
      this.filtro = {dataCompraInicio:  null,dataCompraFim : null, status: null, nomeFavorecido: null };      
    },
    fetchLista() {     
      this.$vs.loading() 
      const params = new URLSearchParams();
      params.append('pagina', -1);
      
      if(this.filtro.dataCompraInicio != null){
        params.append("dataCompraInicio", this.filtro.dataCompraInicio);
      }
      
      if(this.filtro.dataCompraFim != null){
        params.append("dataCompraFim", this.filtro.dataCompraFim);
      }

      if (this.filtro.status) {
        params.append("status", this.filtro.status);
      }

      if (this.filtro.nomeFavorecido) {
        params.append("favorecido.nome", this.filtro.nomeFavorecido);
      }
     
      axios.post(URL_SERVLET, params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/' });
          } else {
              this.totalRegistros = response.data.Resultado.quantidade;
              this.dadosDaGrid = response.data.Resultado.lista;
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
      })    
                        
    },
    routeNovoRegistro() {
      let self_ = this;

      self_.$router.push({
            name: NAME_ROUTE_EDIT                     
      })
    },
    onRowSelectedRegistro(evento) {
      let self_ = this;
      let registro = evento.node.data;
      
      self_.$router.push({
            name: NAME_ROUTE_EDIT,
            params: {
              registroOriginal: registro
            }
      })

    },
    exportarParaCSV() {
      var params = {columnSeparator: ';', fileName: 'Compras.csv'};
      this.configuracaoGrid.gridApi.exportDataAsCsv(params);
    }
    
  },
  mounted() {
    if (this.filtroInicial) {
      this.filtro = JSON.parse(JSON.stringify(this.filtroInicial));
    } else if (this.$store.getters.filtroCompras) {
        this.filtro = JSON.parse(JSON.stringify(this.$store.getters.filtroCompras));
    } else {
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataCompraInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataCompraFim = lastDay.toISOString().split('T')[0];
    }

    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api;
    this.configuracaoGrid.gridApi.sizeColumnsToFit();      
    if (this.$store.state.AppActiveUser.perfil !== 'COMPRAS') {
      this.fetchLista(this.filtro);    
    }
  },
  beforeDestroy() {    
    this.$store.dispatch('setarFiltro', {nomeTela: 'compras' , filtro: this.filtro});
  }
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 410px);
  }
</style>

<style lang="scss" >
  
  .rag-green-outer {
    background-color: rgb(252, 222, 196) !important;
  }

  .rag-amber-outer {
    background-color: rgb(151, 233, 162) !important;
    color: rgb(46, 44, 44)  !important;
  }

</style>